module.exports = __webpack_public_path__ + "img/P150T_weapon_7.ab8652e5.png";